import { useEffect, useState } from "react";
import { axiosPrivate } from 'src/utils/axios';

export function useFetch(url, body , method = "post") {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        async function fetch() {
            setIsLoading(true)
            try {
                const response = await axiosPrivate[method](url, body)
                setData(response.data)
            } catch (error) {
                setError(true)
            }
            finally {
                setIsLoading(false)
            }
        }
        fetch()
    }, [])

    return { data, isLoading, error }
}